import { render, staticRenderFns } from "./Narratage.vue?vue&type=template&id=309665c1&scoped=true&"
import script from "./Narratage.vue?vue&type=script&lang=js&"
export * from "./Narratage.vue?vue&type=script&lang=js&"
import style0 from "./Narratage.vue?vue&type=style&index=0&id=309665c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309665c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/kanghuang/project/Javascript/vue/letter_en/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VImg,VLayout})
